import { useRestClient } from '@/contexts/QueryProvider'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'

// type SupportMenuItem = RestSchemas['Messages.Ui.SupportMenuItem']

// Temp mock data
// import { json } from '@/catalog-apps/mock-data/support-menu/support-menu-response-skills.json'
// const mockData: SupportMenuItem[] = json

export function useGetAppSupportMenu() {
  const { appId, projectId } = useAppContext()
  const { getUiApiGetSupportMenu } = useRestClient()

  return getUiApiGetSupportMenu.useSuspenseQuery(
    {
      query: { applicationId: appId, projectId: projectId },
    },
    {
      staleTime: 24 * 60 * 60 * 1000, // 24 hours
      // TODO: Remove mock data
      // select: () => mockData,
    }
  )
}
